import $ from 'jquery';

export const init_counter_add_to_cart = () => {
	const reduce = document.querySelectorAll('.psh-counter__button--reduce');
	const increment = document.querySelectorAll('.psh-counter__button--increment');
	const number = document.querySelectorAll('.psh-counter__number--amount');

	number.forEach(element => {
		if ( typeof element.dataset.init === 'undefined' ) {
			element.dataset.init = 'true';
			element.addEventListener('change', (event) => {
				if (event.currentTarget.value < 0) {
					event.currentTarget.value = 1;
				}

				check_validation(event, 'onchange');
			});
		}
	});

	reduce.forEach(element => {
		if ( typeof element.dataset.init === 'undefined' ) {
			element.dataset.init = 'true';
			element.addEventListener('click', (event) => {
				check_validation(event, 'min');
			});
		}
	});


	increment.forEach(element => {
		if ( typeof element.dataset.init === 'undefined' ) {
			element.dataset.init = 'true';
			element.addEventListener('click', (event) => {
				check_validation(event, 'plus');
			});
		}
	});

	function check_validation( e, action ) {
		const $parent = $( $( e.currentTarget ).parent( '.psh-counter' ) );
		let $mainBlock = e.currentTarget.closest('.product-new--list');

		if ( $mainBlock === null ) {
			$mainBlock =  e.currentTarget.closest('.product-new--grid');
		}

		const $counter = $( $parent.find( '.psh-counter__number' ) );
		const currentNumber = Number( $counter.val() );
		let newNumber = currentNumber;
		let $maxNumber = parseInt( $counter.attr( 'max' ) );

		if ( $( e.target ).text() === '-' ) {
			if ( currentNumber > 1 ) {
				newNumber = currentNumber - 1;

				if ( newNumber >= $maxNumber && $mainBlock !== null ) {
					setBackOrderValue($mainBlock, newNumber, $maxNumber);
				}
			}
		}

		if ( $( e.target ).text() === '+' && ( currentNumber < $maxNumber || $parent.data('backorder') === true ) ) {
			newNumber = currentNumber + 1;

			if ( newNumber > $maxNumber && $mainBlock !== null ) {
				setBackOrderValue($mainBlock, newNumber, $maxNumber);
			}
		}

		if ( action === 'onchange' && $parent.data('backorder') === true ) {
			setBackOrderValue($mainBlock, currentNumber, $maxNumber);
		}

		if ( action !== 'onchange' ) {
			$counter.val( newNumber ).change();
		}
	}

	function setBackOrderValue(productBlockList, value, maxValue) {
		let backorderDiv = productBlockList.querySelector('.backorder'),
		    backorderAmount = backorderDiv.querySelector('.backorder__value'),
		    backorderValue = 0;


		if ( value > maxValue ) {
			backorderDiv.classList.add( 'visible' );
			backorderValue = value - maxValue;
		} else {
			backorderDiv.classList.remove( 'visible' );
		}

		backorderValue =  backorderValue.toString();
		backorderAmount.innerHTML = backorderValue;
	}
};

init_counter_add_to_cart();